import { ShowProductsBtn } from "~/BearingSelectionAssistant/components/ShowProductsBtn";
import { type RootState } from "../redux/store";
import { selectionAssistantOnMount } from "../Search/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { SATabularView } from "./components/SATabularView";
import Spinner from "../common/components/Spinner/Spinner";
import { useOnMount } from "../common/hooks/useOnMount";
import { NoSearchResults } from "../Search/components/SearchResults/NoSearchResults";
import { SAFilters } from "./components/Filters/SAFilters";
import { ReduxImperialToggle } from "~/ImperialMetricData/components/ImperialToggle/ImperialToggle";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/utils/screenSizes";
import { useTranslation } from "react-i18next";
import { PageTitle } from "~/common/components/PageTitle/v2/PageTitle";

import classes from "./BearingSelectionAssistant.module.less";
import { resetSAFilters } from "~/BearingSelectionAssistant/redux/actions";
import { ResetAllLinkBtn } from "~/BearingSelectionAssistant/components/Buttons/ResetAllBtn";
import {
  PurchasePlaceProvider,
  PurchaseTypeProvider,
} from "~/feature/Analytics/ga/recommendations/RecommendationContexts";

export const BearingSelectionAssistant = () => {
  const dispatch = useDispatch();

  useOnMount(() => {
    dispatch(selectionAssistantOnMount());
  });

  const inFlight = useSelector((state: RootState) => state.srp.inFlight);
  const totalNumberOfResults = useSelector((state: RootState) => state.srp.pagination.totalNumberOfResults);

  const { t } = useTranslation();
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  return (
    <PurchasePlaceProvider value={"BSA"}>
      <PurchaseTypeProvider value={"bsa"}>
        <div className={classes.root}>
          <PageTitle>{t("page.selectionAssistant.title")}</PageTitle>

          {!inFlight && (
            <div className={classes.buttons}>
              <ShowProductsBtn resultAmount={totalNumberOfResults} />
              <ResetAllLinkBtn onClick={() => dispatch(resetSAFilters())} />
            </div>
          )}

          {!isDesktop && <ReduxImperialToggle page={"SA"} className={classes.mobileImperialToggle} />}

          <SAFilters />

          <div id="results" className={"scha__sa__results"}>
            {inFlight && <Spinner />}

            {!inFlight && (
              <>
                {totalNumberOfResults === 0 && <NoSearchResults mode={"short"} variant="filter" />}
                {totalNumberOfResults > 0 && (
                  <SATabularView totalNumberOfResults={totalNumberOfResults} isDesktop={isDesktop} />
                )}
              </>
            )}
          </div>
        </div>
      </PurchaseTypeProvider>
    </PurchasePlaceProvider>
  );
};

export function createSelectionAssistant() {
  return <BearingSelectionAssistant />;
}
